import { createContext, useCallback, useContext, useState } from "react";

// ═══════════════════════════════════════════════════════════════════════════════
// GUEST CONTEXT
// ═══════════════════════════════════════════════════════════════════════════════
// Parallel auth path for non-PPUSA viewers. A signed-in guest gets read-only
// access to Pipeline + Map; everything else (Sourcing, Inbox, Comps, Settings,
// Add Deal, Upload OM, edits, deletes, document upload, chat) is hidden or
// disabled. Persisted in localStorage so a refresh keeps the session.

const STORAGE_KEY = "pp-guest-session";
const GUEST_USERNAME = "Guest";
const GUEST_PASSWORD = "ProxyGuest2026!";

const GuestContext = createContext({
  isGuest: false,
  signIn: () => false,
  signOut: () => {},
});

export function GuestProvider({ children }) {
  const [isGuest, setIsGuest] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === "true"; } catch { return false; }
  });

  const signIn = useCallback((username, password) => {
    if (username?.trim() === GUEST_USERNAME && password === GUEST_PASSWORD) {
      try { localStorage.setItem(STORAGE_KEY, "true"); } catch {}
      setIsGuest(true);
      return true;
    }
    return false;
  }, []);

  const signOut = useCallback(() => {
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
    setIsGuest(false);
  }, []);

  return (
    <GuestContext.Provider value={{ isGuest, signIn, signOut }}>
      {children}
    </GuestContext.Provider>
  );
}

export function useGuest() {
  return useContext(GuestContext);
}
